export default __webpack_public_path__ + "static/media/mission.8dc67dde.jpg";